import { DivButton } from "@/components/ui/button";
import { PlusIcon, SwitchHorizontalIcon } from "@heroicons/react/solid";
import { forwardRef } from "react";

const SelectedExamplesBanner = forwardRef<
  HTMLDivElement,
  {
    onClick?: () => void;
    selectedCount?: number;
    singleSelect?: boolean;
  }
>(({ onClick, selectedCount = 0, singleSelect }, ref) => {
  if (singleSelect) {
    return (
      <DivButton
        ref={ref}
        className={`inline-block items-center justify-between whitespace-nowrap transition-all ease-in-out ${
          selectedCount === 0
            ? "border border-dashed border-gray-300 bg-transparent text-gray-400 hover:bg-gray-50"
            : ""
        }`}
        onClick={onClick}
        variant={selectedCount > 0 ? "blueOutline" : "outline"}
      >
        {selectedCount === 0 ? (
          <>
            <PlusIcon className="mr-1 inline h-4 w-4" />
            Select Input
          </>
        ) : (
          <>
            <SwitchHorizontalIcon className="mr-1 inline h-4 w-4" />
            Change Input
          </>
        )}
      </DivButton>
    );
  }

  return (
    <DivButton
      ref={ref}
      className="inline-block items-center justify-between whitespace-nowrap"
      onClick={onClick}
    >
      <PlusIcon className="mr-1 inline h-4 w-4" />
      Add Example(s)
    </DivButton>
  );
});

SelectedExamplesBanner.displayName = "SelectedExamplesBanner";

export default SelectedExamplesBanner;
